import React, {Component} from 'react';
import Modal from 'react-modal';
import firebase from 'firebase';
import moment from 'moment';
import './informacion.css';
import Alert from 'react-s-alert';
import store from '../../store';
import buscarNodo from './buscarNodo'
import copyright from '../../img/copyright-gray.png';
import * as XLSX from 'xlsx'
import { sendLog } from '../../util'

const database=firebase.database();
const buscarCliente = buscarNodo('Clientes');

class Informacion extends  Component{
	constructor(props){	
		super(props);
		this.state={
			nombre:'',
			direccion:'',
			logo:'',
			mision:'',
			vision:'',
			uploadValue:0,
			files:null,
			template:true,
			actual: 0
			
		}
		this.informacionRef=database.ref().child('informacion_empresa');
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleUpload=this.handleUpload.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		// this.quitarGuion();
		// this.arerglarFechas();
		// this.scriptLiberar();
		// this.scriptDuiSinGuion();
		// this.modificarPasajeros();
		// this.verificarVelocidades();
		// this.nuevoUsuario();
		// this.intentos();
	
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			sendLog({ tipo: 'informacion_empresa_propietaria_editado' });
			this.handleSubmit();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
				<div className='s-alert-box-inner'>
						{message}
				</div>
				<br/>
				<br/>
				<button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
				<button className="customButton btn btn-success btn-alerts btn-m-r" onClick={handleClose.bind(this)}>Cancelar</button>
				<span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
	}

	arerglarFechas = async ()=>{
		const fechaInicial = moment(new Date(2020,2,1));

		for (let i = 0; i < 31; i++) {
			const fechaStr = new Date(fechaInicial.year(), fechaInicial.month(), fechaInicial.date()+i).toString();

			const snap = await firebase.database().ref().child('ProgramacionDia').orderByChild('fecha').equalTo(fechaStr).once('value');
			const data = snap.val();

			const prograDias=[];
			for (const key in data) {
				firebase.database().ref().child('ProgramacionDia').child(key)
				.update({
					horaInicio:data[key].programacionF.horaReco,
					horaLlegada:data[key].programacionF.horaAero

				});
				prograDias.push(key);
			}
			console.log('fechaStr :', fechaStr, prograDias.length);
		}

	}

	scriptLiberar=async ()=>{
		const snapEmpleados = await firebase.database().ref('Empleados').once('value');
		const dataEmpleados = snapEmpleados.val();

		for (const key in dataEmpleados) {
			firebase.database().ref('Empleados').child(key).update({ true: false, viajeAsignado: false })
		}

		const snapVehiculos = await firebase.database().ref('Vehiculos').once('value');
		const dataVehiculos = snapVehiculos.val();
		for (const key in dataVehiculos) {
			firebase.database().ref('Vehiculos').child(key).update({ estado: 'Disponible', viajeAsignado: false });
		}
	}

	logs=async()=>{
		const snap = await firebase.database().ref('logs').orderByChild('fecha').equalTo('2019/12/26').once('value')
		const data = snap.val();

		const arr = Object.values(data).filter(el=> el.usuario==='jsKjfLydqZOvVPAyaarU6GCk9MJ3');

		console.log('arr :', arr);
	}

	modificarPasajeros = async ()=>{
		const fechaInicial = moment(new Date(2019,9,8));
		for (let i = 0; i < 1; i++) {
			const fechaStr = new Date(fechaInicial.year(), fechaInicial.month(), fechaInicial.date()).toString();
			console.log('fechaStr :', fechaStr);
			const snap = await firebase.database().ref().child('ProgramacionDia').orderByChild('fecha').equalTo(fechaStr).once('value');
			const data = snap.val();
	
			const prograDias=[];
			for (const key in data) {
				if(data[key].Pasajeros){
					for (const i in data[key].Pasajeros) {
						const resCliente = await buscarCliente(data[key].Pasajeros[i].codigo);
							data[key].Pasajeros[i].numero_empleado = resCliente && resCliente.numero_empleado || 0 ;
							data[key].Pasajeros[i].centroCosto     = resCliente && resCliente.centro || '';
							data[key].Pasajeros[i].areaU           = resCliente && resCliente.areaDesc || '';
							data[key].Pasajeros[i].coordenadas     = resCliente && resCliente.coordenadas && resCliente.coordenadas.coordenadas || false;
							data[key].Pasajeros[i].escalafon       = resCliente && resCliente.escalafon || '' ;
					}
					firebase.database().ref().child('ProgramacionDia').child(key).update({Pasajeros:data[key].Pasajeros});
					prograDias.push(key);
				}
			}
			console.log('prograDias :', prograDias);

			fechaInicial.add(1,'d');
		}
	}

	nuevoUsuario = ()=>{
		const uid = '9Xea5zdaUDZ4re4oQjKzCn8eYyB3';
		const obj = {
			correo: "jorge.garcia@grupobacer.com",
			estado: "Activo",
			nombre: "Jorge Garcia",
			perfil: "Administrador",
		}

		firebase.database().ref().child('Usuarios_Acacya').update({[uid]:obj});
	}
	
	handleClickAlerta(event){
		this.setState({
			template:true			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}

	intentos = async ()=>{
		const snap = await firebase.database().ref().child('logs').orderByChild('tipo').equalTo('intent_login_conductor').once('value');
		const data = Object.values(snap.val());
	}

	componentWillUnmount = () => {
		this.informacionRef.off();
	}

	verificarVelocidades = async () => {
		const fecha = new Date(2019, 6, 19);
		const strFecha = fecha.toString();
		
		const snap = await firebase.database().ref().child('ProgramacionDia').orderByChild('fecha').equalTo(strFecha).once('value');
		const data = snap.val();
		const records = [];
		
		for (const key in data) {
			if(data[key].estado =='Finalizado')
				data[key].key=key;
				records.push(data[key]);
		}

		for (const item of records) {

			const result = await this.calcularVMax(item.key);
			if(result && result.vProm && result.vMax){
				// console.log('result.vProm :', result.vProm);
				// console.log('vMax :', result.vMax);
				await firebase.database().ref().child('ProgramacionDia').child(item.key).update({
					vProm: result.vProm,
					vMax : result.vMax
				})
			}
		}

		// console.log('records:', records);
	}

	calcularVMax = async (id) =>{
        try {
            const snap     = await firebase.database().ref('DatosViajes/' + id).once('value');
            const dataProg = snap.val();
            const obj      = {};

            if(dataProg && dataProg.velocidad && dataProg.velocidad.length){
                let numeros     = dataProg.velocidad.map(val=> Number(val));
                numeros         = numeros.filter(val=> !isNaN(val));
                const max       = (Math.max(...numeros)).toFixed(2);

                const sumatoria = numeros
                .reduce((acumulador, siguienteValor) => {
                    return acumulador + siguienteValor;
                }, 0);

                const promedio = (sumatoria==0 ) ? 0 :
                (sumatoria / dataProg.velocidad.length).toFixed(2);
                
                obj.vProm = promedio;
                obj.vMax = max;
            }

            return obj;
        } catch (error) {   
            console.log('error :', error);
        }
    }

	prograsDia = async () => {

		// const progras = new Set();
		// for (let i = 18; i < 31; i++) {
			const fecha = new Date(2019,6,17);
			// console.log('String(fecha) :', String(fecha));
	
			const snap = await firebase.database().ref('ProgramacionDia').orderByChild('fecha').equalTo(String(fecha)).once('value');
			const data = snap.val();
			const dataValues = [];
	
			for (const key in data) {
				data[key].key = key;
				if(data[key].horaInicio=='16:30')
					dataValues.push(data[key]);
			// 	if(data[key].estado !="Pendiente" || data[key].estado != 'Inactivo'){
			// 		if(!progras.has(data[key].programacion)){

			// 			progras.add(data[key].programacion);
			// 			await firebase.database().ref('Programacion').child(data[key].programacion).update({isOnlyRead: true});
			// 			console.log('ko');
			// 		}
			// 	}
			}

			console.log('dataValues :', dataValues);
			// console.log('progras :', progras);
		// }

	}
	
	componentDidMount(){
		firebase.auth().currentUser.getIdToken().then(token=>console.log('token :', token));
		// this.getData();
		this.informacionRef.off();
		this.informacionRef.on('value',this.gotData,this.errData);
		//this.getDatosTarifas();//Obtiene los datos de las tarifas y le agrega el 2%
	}

	getDatosTarifas=async()=>{
		const datos = [];
		let datosM = [];
		const snap = await database.ref('TarifasAvianca').once("value");
		
		const data = snap.val();
		Object.assign(datos, Object.values(data).map((el, i )=>{el.key = Object.keys(data)[i]; return el;}) )
		//console.log('datos previos :', datos);
		datos.map((el,i)=>{
			const obj = JSON.parse(JSON.stringify(el));

			obj.valores.Sedan = ((el.valores.Sedan*1.02)).toFixed(2);
			obj.valores.Microbus = (el.valores.Microbus*1.02).toFixed(2);
			obj.valores.Coaster = (el.valores.Coaster*1.02).toFixed(2);
			datosM.push(obj);
		});
		
		//console.log('datos :', datosM);
	}

	scriptDuiSinGuion = async () => {
		console.clear();
		console.log('aaaaaah');
		const snapClientes = await firebase.database().ref('/Clientes').once('value');
		const clientes = snapClientes.val();
		for (const key in clientes) {
			if(clientes[key].dui){
				const pattern = /-/;
				if(pattern.test(clientes[key].dui)){
					console.log('key :', key);
					const newDui = clientes[key].dui.split('-').join('');
					firebase.database().ref().child('Clientes').child(key).update({dui:newDui})
					.then(()=>console.log('oks'))
					.catch(err=>console.log('err :', err));
				}
			}
		}
	}

	capturaDatos = (event) => {
		try {
			let datos = [];
			var done = false;
			var file = event.target.files[0];
			const reader = new FileReader();

			reader.onloadend = (event) => {
				const bstr = event.target.result;
				const wb = XLSX.read(bstr, {type:'binary'});

				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];

				const data = XLSX.utils.sheet_to_json(ws, {header:"A"});
				
				firebase.database().ref('Clientes').once('value').then(snap =>{
					let clientes = [];
					snap.forEach(element => {
						let data = element.val();
						data.key = element.key;
						clientes.push(data)
					});
					firebase.database().ref('CentroCosto').once('value').then(snapC =>{
						let centros = [];
						snapC.forEach(element => {
							let data = element.val();
							data.key = element.key;
							centros.push(data)
						});
						let clientesM = [];
						data.forEach((element, index) => {
							if(index !== 0){
								let centroN = centros.find(c => c.codigo === element.C)
								let clientesF = clientes.find(cl => cl.numero_empleado === element.A)
								if(clientesF === undefined || centroN === undefined){
									// console.log(element.A)
								}else{
									clientesF.centro = centroN.key;
									clientesM.push(clientesF)
								}
							}
						});
						clientesM.forEach(element => {
							firebase.database().ref().child('Clientes/'+element.key).update({
								centro: element.centro
							}, () => console.log('bien'))
						});
						console.log(clientesM)
					})
				})
			}
			reader.readAsBinaryString(file);
		}
		catch(error) {
			console.log(error.message);
		}
	}
	
	gotData = (data) => {
			const informacionData = data.val();
			this.nombreEmpresa.value=informacionData['informacion'].nombre;
			this.direccionEmpresa.value=informacionData['informacion'].direccion;
			this.visionEmpresa.value=informacionData['informacion'].vision;
			this.misionEmpresa.value=informacionData['informacion'].mision;
			this.setState({ 
				 logo:informacionData['informacion'].logo
				 
			}); 
		}
		errData = (err) => {
			console.log(err);
		}
	
	
		handleSubmit(){
		
		sendLog({ tipo: 'informacion_empresa_propietaria_editado' });
		let nombre=this.nombreEmpresa.value;
		let direccion=this.direccionEmpresa.value;
		let vision=this.visionEmpresa.value;
		let mision=this.misionEmpresa.value;
	
		
		let archivo=this.state.files;
		
		if(this.state.files===null){

				this.informacionRef.child('informacion').update({
							
							nombre:nombre,
							direccion:direccion,
							mision:mision,
							vision:vision,
									
				});
			
				Alert.success('Datos guardados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
			
		}
		else{
				
				
				const storageRef = firebase.storage().ref(`Empleados/${archivo.name}`);
				
				const task= storageRef.put(archivo);
				
				task.on('state_changed', snapshot =>{
				
				
				this.setState({
				  uploadValue :50,
				})

				}, error =>{ console.log(error.message);
				},
				async()=>{
					const url = await task.snapshot.ref.getDownloadURL()
					
					
			
					this.informacionRef.child('informacion').update({
						
						nombre:nombre,
						direccion:direccion,
						mision:mision,
						vision:vision,
						logo:url
								
					});
					
				
					this.setState({
						uploadValue:100
					});
					
				
					Alert.success('Datos guardados correctamente', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});

				});
		
		}
			
	}
	
	
	handleUpload(e,filee){
		
		var file= e.target.files[0],
		pattern= /image-*/,
		reader=new FileReader();
		
		if(file===undefined){
			
			this.setState({ 
				 logo:null,
				 files:null
			}); 
			
		}
		else{
			
			if(!file.type.match(pattern)){
			
					alert('Por favor ingresa una imagen con formato valido');
					return;
				}
		


				reader.onload = (e) => {
					this.setState({ 
						logo:reader.result,
						files:file
					}); 
				}		
			
				reader.readAsDataURL(file);
						
		}

		
		
		
	}
	
	
		ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}

	getData = () => {
    	firebase.database().ref('DatosViajes').once('value').then(snap =>{
			let datosViajes = [];
			snap.forEach(element => {
				let datos = element.val();
				datos.key = element.key;
				datosViajes.push(datos)
			});
			this.validar( datosViajes );
		})
}


validar = (datosViajes) => {
    firebase.database().ref('ProgramacionDia').once('value').then(snap =>{
        let validos = []
        snap.forEach(element => {
            let datos = element.val();
			datos.key = element.key;
			if(datos.estado === 'Finalizado'){
				let datos = datosViajes.find(snap => snap.key === element.key);
				if(datos !== undefined){
					if(datos.velocidad !== undefined && Array.isArray(datos.velocidad)){
						var max = Math.max.apply(null, datos.velocidad);
						var sumatoria = datos.velocidad.reduce((acumulador, siguienteValor) => {
							return acumulador + siguienteValor;
						  }, 0);
						var promedio = (sumatoria / datos.velocidad.length).toFixed(2);

						if(promedio >= 0 && max >= 0){
							datos = {key: datos.key, vProm: (promedio*3.6), vMax: (max*3.6)}
							validos.push(datos)
						}
					}
				}
			}
        });
        setTimeout(() => {
            let { actual } = this.state;
            for (let index = actual; index < (actual+6175); index++) {
                let datos = validos[index];
                firebase.database().ref().child('ProgramacionDia/'+datos.key).update({
					vProm: datos.vProm, 
					vMax: datos.vMax
                }).then(snap =>{
                    // console.log('Bien '+snap)
                }).catch(error =>{
                    // console.log('Mal '+snap)
                })
            }
        }, 2500);
        // console.log(validos);
    })
}
	
	render(){
		
		return(

		// <div className="col-sm">
		// 	<label className="custom-file-label" for="excel">Seleccionar fila</label>
		// 	<input type="file" className="custom-file-input" id="excel" onChange={this.capturaDatos}/>
		// </div>
		
			<div className="Informacion container" onClick={this.ocultarMenu}>
				
					
					{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido.bind(this)}/>:<Alert stack={{limit: 3}} html={true} />}

					<div className="row cn">
						<div className="col-md-12">
							<form method="POST" action="" onSubmit={this.handleClickAlerta}>
								
								<div className="form-group">
									<label htmlFor="nombreEmpresa">Nombre de la empresa:</label>
									<input type="text" name="nombreEmpresa" className="form-control" 
									placeholder="Nombre Empresa" ref={input=>{this.nombreEmpresa=input;}}
									required autoComplete="off"
						
									/>
								</div>
								
								<div className="form-group">
									<label htmlFor="direcccionEmpresa">Dirección:</label>
									<input type="text" name="direcccionEmpresa" className="form-control" 
									placeholder="Dirección Empresa" 
									ref={input=>{this.direccionEmpresa=input;}}
									required autoComplete="off"
									/>
								</div>
								
								<div className="form-group">
									<label htmlFor="foto">Logo de la empresa</label>
									<br/>
									<progress value={this.state.uploadValue} max="100"></progress>
									<input type="file" className="form-control"  onChange={this.handleUpload}/>
								    <img src={this.state.logo} alt="Logo empresa" className="foto" width="240px"
											
									/>
								</div>

								
								<div className="form-group">
									<label htmlFor="mision">Mision:</label>
									<textarea className="form-control" placeholder="Misión..." 
									ref={input=>{this.misionEmpresa=input;}}
									required autoComplete="off" rows="6"
									></textarea>
									
								</div>
								
								<div className="form-group">
									<label htmlFor="vision">Vision:</label>
									<textarea className="form-control" placeholder="Visión..." 
									ref={input=>{this.visionEmpresa=input;}}
									required autoComplete="off" rows="6"
									></textarea>
								</div>
								
								<div className="form-group">
									<button type="submit" className="btn btn-success">Modificar</button>
								</div>
							
							</form>
						</div>
					</div>
					<footer class="footer-pg mt-auto py-3" style={{width:'100%'}}>
						<div class="container">
							<div class="row">
								<div className="col-md-4 col-sm-4">
								</div>
								<div class="col-sm">
									<img src={copyright}/>
								</div>
							</div>
						</div>
					</footer>
			</div>
		
		
		
		);
		
	}
}

export default Informacion;


// WEBPACK FOOTER //
// ./src/Components/Informacion/Informacion.jsx